import { Injectable } from '@angular/core';

@Injectable()
export class Storage {
    static get(key) {
        return window.localStorage.getItem(key);
    }

    static set(key, value) {
        return window.localStorage.setItem(key, value);
    }
}


// WEBPACK FOOTER //
// /Users/jaswantsingh/Documents/GitHub/maps/src/app/core/utilities/storage.ts